import script from "./ModalNumero.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalNumero.vue?vue&type=script&setup=true&lang=js"

import "./ModalNumero.vue?vue&type=style&index=0&id=5ce4bd15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce4bd15"]])

export default __exports__